import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import { Card, Col, Row } from "antd";
import dayjs from "dayjs";

HighchartsMore(Highcharts);

const ColdStorageChart2 = ({ data }) => {
  console.log("DATA CS 2", data);

  const [minDate, setMinDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);
  const [temperatureData, setTemperatureData] = useState([]);
  const [doorData, setDoorData] = useState([]);

  useEffect(() => {
    if (data?.TemperatureDoorStatuses?.length) {
      // Sort full dataset
      const sorted = [...data.TemperatureDoorStatuses].sort(
        (a, b) => dayjs(a.createdAt).valueOf() - dayjs(b.createdAt).valueOf()
      );

      // Filter temperature-only and door-only entries
      const temperatureOnly = sorted.filter(
        (item) => item.temperature !== undefined && item.temperature !== null
      );
      const doorOnly = sorted.filter(
        (item) => item.doorStatus !== undefined && item.doorStatus !== null
      );

      // Generate timestamped series
      const temperatureData = temperatureOnly.map((item) => [
        dayjs(item.createdAt).valueOf(),
        item.temperature,
      ]);

      const doorData = doorOnly.map((item) => [
        dayjs(item.createdAt).valueOf(),
        item.doorStatus,
      ]);

      // Combine both sets to get overall x-axis bounds
      const timestamps = [...temperatureData, ...doorData].map(([ts]) => ts);

      setTemperatureData(temperatureData);
      setDoorData(doorData);

      const now = dayjs().valueOf();
      const oneHourAgo = dayjs().subtract(1, "hour").valueOf();

      setMinDate(oneHourAgo);
      setMaxDate(now);
    }
  }, [data]);

  const options = {
    title: {
      text: "Cold Storage 2",
    },
    time: {
      timezone: "Asia/Jakarta",
    },
    chart: {
      type: "spline",
      zoomType: "x",
      panning: true,
      panKey: "shift",
    },
    xAxis: {
      type: "datetime",
      scrollbar: {
        enabled: true,
      },
      min: minDate,
      max: maxDate,
      labels: {
        rotation: -45,
      },
    },
    yAxis: [
      {
        title: { text: "Temperature" },
      },
      {
        title: { text: "Door" },
        opposite: true,
      },
    ],
    series: [
      {
        name: "Temperature",
        data: temperatureData,
        color: "#FFE44D",
        type: "areaspline",
        fillOpacity: 0.1,
      },
      {
        name: "Door",
        data: doorData,
        color: "#35F240",
        type: "line",
        step: "left",
        yAxis: 1,
      },
    ],
    legend: {
      layout: "horizontal",
    },
    credits: {
      enabled: false,
    },
  };

  return (
    <Card>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Card>
  );
};

export default ColdStorageChart2;
